import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QrCode, Zap, Check, Radio } from "lucide-react";
import api from "@/lib/api";

const rm = (n) => "RM " + (n || 0).toLocaleString("en-MY");

export default function LeadMagnet() {
  const { sid } = useParams();
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ name: "", phone: "" });
  const [done, setDone] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/live/${sid}/magnet`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [sid]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) return;
    try {
      const r = await api.post(`/live/${sid}/capture`, { session_id: sid, name: form.name, phone: form.phone });
      setMsg(r.data.message); setDone(true);
    } catch (e) { setMsg("Something went wrong. Try again."); }
  };

  if (err) return <div className="min-h-screen flex items-center justify-center bg-[#090B0E] text-slate-400 font-mono">Live session not found.</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center bg-[#090B0E] text-slate-400 font-mono animate-pulse">Loading live promo…</div>;

  return (
    <div className="min-h-screen bg-[#090B0E] text-white flex items-center justify-center p-4">
      <div className="absolute top-6 left-1/2 -translate-x-1/2 flex items-center gap-2 text-xs font-mono">
        <span className="h-2 w-2 rounded-full bg-[#E5253A] live-dot" /> YES GO LIVE
      </div>
      <div className="w-full max-w-sm rounded-2xl border border-[#21283B] bg-[#11141C] overflow-hidden fade-in">
        <div className="bg-gradient-to-br from-[#E5253A]/20 to-transparent p-6 text-center border-b border-[#21283B]">
          <div className="text-[10px] font-mono text-amber-400">🔥 LIVE PROMO · {data.session_title}</div>
          {data.offer && (
            <>
              <h1 className="mt-2 text-xl font-extrabold tracking-tight">{data.offer.title}</h1>
              <div className="text-xs text-slate-400 mt-1">{data.offer.subtitle}</div>
              <div className="mt-3 text-3xl font-mono font-extrabold text-emerald-400">{rm(data.offer.price)}</div>
              {data.offer.seats_remaining != null && <div className="text-[11px] font-mono text-amber-400 mt-1">Seats Remaining: {data.offer.seats_remaining}</div>}
            </>
          )}
        </div>
        {done ? (
          <div className="p-8 text-center">
            <div className="h-14 w-14 rounded-full bg-emerald-500/15 flex items-center justify-center mx-auto"><Check className="h-7 w-7 text-emerald-400" /></div>
            <div className="mt-4 text-sm">{msg}</div>
          </div>
        ) : (
          <form onSubmit={submit} className="p-6 space-y-3">
            <p className="text-xs text-slate-400 text-center">Isi nama & telefon untuk dapatkan promo live eksklusif.</p>
            <input data-testid="magnet-name" placeholder="Nama Anda" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full h-11 px-3 rounded-lg border border-[#21283B] bg-[#090B0E] text-sm" />
            <input data-testid="magnet-phone" placeholder="Telefon / WhatsApp" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full h-11 px-3 rounded-lg border border-[#21283B] bg-[#090B0E] text-sm" />
            <button data-testid="magnet-submit" type="submit" className="w-full h-11 rounded-lg bg-[#E5253A] hover:bg-[#c71f31] text-white font-bold flex items-center justify-center gap-2"><Zap className="h-4 w-4" /> Claim Promo</button>
            <div className="flex items-center justify-center gap-2 text-[10px] text-slate-500 font-mono pt-1"><QrCode className="h-3 w-3" /> Source: YES GO LIVE · Host {data.host}</div>
          </form>
        )}
      </div>
    </div>
  );
}
